import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { OFRResponse } from '../models/commonServiceModels';
import { Dashboard, CaseFilter, CaseByPageModel, Case, PingCase } from '../models/caseModel';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class CaseService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public DownloadCases(startDateDeath: string, endDateDeath: string, startDateReview: string, endDateReview: string, caseStatus: string,
        mannerOfDeath: string, type: string, groups: string, fatal: boolean, nonFatal: boolean, isArchived: boolean): Promise<string> {
        return this.httpgettext('/case/download/cases?startDateDeath=' + startDateDeath + '&endDateDeath='
         + endDateDeath + '&startDateReview=' + startDateReview + '&endDateReview=' + endDateReview +
            '&caseStatus=' + caseStatus +
            '&mannerOfDeath=' +  mannerOfDeath +
            '&type=' + type + '&groups=' + groups +
            '&fatal=' + String(fatal) + '&nonFatal=' + String(nonFatal) +
            '&isArchived=' + String(isArchived)
        );
    }

    public getDashboard(): Promise<Dashboard> {
        return this.httpget<Dashboard>('/case/');
    }

    public getDismissedCases(filter: CaseFilter): Promise<CaseByPageModel> {
        return this.httpget<CaseByPageModel>(`/case/dismissed`, filter);
    }

    public getOpenCases(filter: CaseFilter): Promise<CaseByPageModel> {
        return this.httpget<CaseByPageModel>(`/case/open`, filter);
    }

    public getAvailableCases(filter: CaseFilter): Promise<CaseByPageModel> {
        return this.httpget<CaseByPageModel>(`/case/available`, filter);
    }

    public getCaseCount(casetype: string): Promise<number> {
        return this.httpget<number>(`/case/count/${casetype}`);
    }

    public getCaseInformation(id: string): Promise<Case> {
        return this.httpget<Case>(`/case/${id}`);
    }

    public getSubmittedCases(filter: CaseFilter): Promise<CaseByPageModel> {
        return this.httpget<CaseByPageModel>(`/case/submitted`, filter);
    }

    public PingCase(id: string): Promise<PingCase> {
        return this.httppost<PingCase>(`/case/${id}/ping`, {});
    }

    public saveCase(id: string, data: any): Promise<OFRResponse> {
        return this.httppost<OFRResponse>(`/case/${id}`, data);
    }

    public submitCase(id: string, data: any): Promise<OFRResponse> {
        return this.httppost<OFRResponse>(`/case/${id}/submit`, data);
    }

    public updateCaseStatus(id: string, newStatus: any): Promise<OFRResponse> {
        return this.httppost<OFRResponse>(`/case/${id}/${newStatus}/updatestatus`, {});
    }

    public setArchivalStatus(id: string, archive: boolean): Promise<OFRResponse> {
        var body = {
            'archive': archive
        };
        return this.httpput<OFRResponse>(`/case/${id}/archive`, body);
    }
    
    public ArchiveCases(input: any) {
        return this.httpput('/case/archive', input);
    }

    public printOcmeDetails(id: any) {
        var params = {
            'id' : id
        }
        return this.httpgetblob(`/case/printOcmeDetails`, params);
    }

    public printFormDetails(details: any) {
        return this.httppostblob(`/case/printFormDetails`, details);
    }

    public printAlertDetails(details: any) {
        return this.httppostblob(`/case/printAlertDetails`, details);
    }
}

